module.exports = __webpack_public_path__ + "7d8870aca8dac76cc534ba5339777dd9.svg";